<template>
    <div class="form-data-component">
        <v-form ref="form" v-model="validForm">
            <v-text-field
                :label="trans[lang].fields.name"
                color="white"
                v-model="name"
                :rules="[v => !!v || compulsory('name')]"
                solo
                flat
                dense
                rounded
                autocomplete="off"
                hide-details="auto"
            ></v-text-field>
            <v-text-field
                :label="trans[lang].fields.lastName"
                color="white"
                v-model="surname"
                :rules="[v => !!v || compulsory('lastName')]"
                solo
                flat
                dense
                rounded
                autocomplete="off"
                hide-details="auto"
            ></v-text-field>
            <v-text-field
                :label="trans[lang].fields.dni"
                color="white"
                v-model="dni"
                :rules="[v => !!v || 'DNI ' + trans[lang].compulsory]"
                solo
                flat
                dense
                rounded
                autocomplete="off"
                hide-details="auto"
            ></v-text-field>
            <slot></slot>
            <v-text-field
                :label="trans[lang].fields.phone"
                color="white"
                v-model="phone"
                :rules="phoneRules"
                solo
                flat
                dense
                rounded
                autocomplete="off"
                hide-details="auto"
            ></v-text-field>
            <v-text-field
                :label="trans[lang].fields.dateOfBirth"
                color="white"
                v-model="dateOfBirth"
                :rules="dateOfBirthRules"
                solo
                flat
                dense
                rounded
                autocomplete="off"
                hide-details="auto"
            ></v-text-field>
            <v-text-field
                :label="trans[lang].fields.email"
                color="white"
                v-model="email"
                :rules="emailRules"
                solo
                flat
                dense
                rounded
                autocomplete="off"
                hide-details="auto"
            ></v-text-field>
            <v-text-field
                :label="trans[lang].fields.address"
                color="white"
                v-model="address"
                :rules="[v => !!v || compulsory('address')]"
                solo
                flat
                dense
                rounded
                autocomplete="off"
                hide-details="auto"
            ></v-text-field>
            <v-text-field
                :label="trans[lang].fields.city"
                color="white"
                v-model="city"
                :rules="[v => !!v || compulsory('city')]"
                solo
                flat
                dense
                rounded
                autocomplete="off"
                hide-details="auto"
            ></v-text-field>
            <v-text-field
                :label="trans[lang].fields.postalCode"
                color="white"
                v-model="postalCode"
                :rules="[v => !!v || compulsory('postalCode')]"
                solo
                flat
                dense
                rounded
                autocomplete="off"
                hide-details="auto"
            ></v-text-field>
            <v-textarea
            :label="trans[lang].fields.deposit"
            :rules="[v => !!v || compulsory('deposit')]"
            color="white"
            v-model="deposit"
            solo
            flat
            rounded
            hide-details="auto"
            autocomplete="off"
            >

            </v-textarea>
        </v-form>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

const trans = {
    ca: {
        fields: {
            deposit: "Què estàs ingressant?*",
            name: "Nom de l'alumne/a*",
            lastName: "Cognoms de l'alumne/a*",
            phone: "Teléfon mòbil*",
            dni: "DNI*",
            email: "Correu electrònic*",
            dateOfBirth: "Data de naixement (dd/mm/aaaa)*",
            address: "Adreça*",
            city: "Població*",
            postalCode: "Codi postal*",
        },
        emailRules: [
            "* Correu electrònic obligatori",
            "* El correu electrònic ha de ser vàlid"
        ],
        phoneRules: ["* Telèfon obligatori", "* El telèfon ha de contenir 9 dígits"],
        dateOfBirthRules: [
            "* Data de naixement obligatòria",
            "* El format de la data de naixement no és correcte"
        ],
        compulsory: "obligatori"
    },
    es: {
        fields: {
            deposit: "¿Qué estás ingresando?*",
            name: "Nombre del alumno/a*",
            lastName: "Apellidos del alumno/a*",
            phone: "Teléfono móvil*",
            dni: "DNI*",
            email: "Correo electrónico*",
            dateOfBirth: "Fecha de nacimiento (dd/mm/aaaa)*",
            address: "Dirección*",
            city: "Población*",
            postalCode: "Código postal*",
        },
        emailRules: [
            "* Correo electrónico obligatorio",
            "* El correo electrónico debe ser válido"
        ],
        phoneRules: ["* Teléfono obligatorio", "* El tetéfono debe contener 9 dígitos"],
        dateOfBirthRules: [
            "* Fecha de nacimiento obligatoria",
            "* El formato de la fecha de nacimiento no es correcto"
        ],
        compulsory: "obligatorio"
    }
};

export default {
    data: () => ({
        trans,
        emailRules: [
            v => !!v || trans[window.appLocale].emailRules[0],
            v => /.+@.+\..+/.test(v) || trans[window.appLocale].emailRules[1]
        ],
        phoneRules: [
            v => !!v || trans[window.appLocale].phoneRules[0],
            v => /^\d{9}$/.test(v) || trans[window.appLocale].phoneRules[1]
        ],
        dateOfBirthRules: [
            v => !!v || trans[window.appLocale].dateOfBirthRules[0],
            v =>
                /^\d{2}\/\d{2}\/\d{4}$/.test(v) ||
                trans[window.appLocale].dateOfBirthRules[1]
        ],
        lang: ""
    }),
    computed: {
        ...mapGetters(["formData"]),
        validForm: {
            get() {
                return this.$store.getters.validForm;
            },
            set(value) {
                this.setValidForm(value);
            }
        },
        name: {
            get() {
                return this.$store.getters.getFormData.name;
            },
            set(payload) {
                this.setParamFromFormData({
                    param: "name",
                    value: payload
                });
            }
        },
        surname: {
            get() {
                return this.$store.getters.getFormData.surname;
            },
            set(payload) {
                this.setParamFromFormData({
                    param: "surname",
                    value: payload
                });
            }
        },
        email: {
            get() {
                return this.$store.getters.getFormData.email;
            },
            set(payload) {
                this.setParamFromFormData({
                    param: "email",
                    value: payload
                });
            }
        },
        dni: {
            get() {
                return this.$store.getters.getFormData.dni;
            },
            set(payload) {
                this.setParamFromFormData({
                    param: "dni",
                    value: payload
                });
            }
        },
        phone: {
            get() {
                return this.$store.getters.getFormData.phone;
            },
            set(payload) {
                this.setParamFromFormData({
                    param: "phone",
                    value: payload
                });
            }
        },
        address: {
            get() {
                return this.$store.getters.getFormData.address;
            },
            set(payload) {
                this.setParamFromFormData({
                    param: "address",
                    value: payload
                });
            }
        },
        city: {
            get() {
                return this.$store.getters.getFormData.city;
            },
            set(payload) {
                this.setParamFromFormData({
                    param: "city",
                    value: payload
                });
            }
        },
        postalCode: {
            get() {
                return this.$store.getters.getFormData.postalCode;
            },
            set(payload) {
                this.setParamFromFormData({
                    param: "postalCode",
                    value: payload
                });
            }
        },
        dateOfBirth: {
            get() {
                return this.$store.getters.getFormData.dateOfBirth;
            },
            set(payload) {
                this.setParamFromFormData({
                    param: "dateOfBirth",
                    value: payload
                });
            }
        },
        deposit:{
            get() {
                return this.$store.getters.getFormData.text;
            },
            set(payload) {
                this.setParamFromFormData({
                    param: "text",
                    value: payload
                });
            }
        }
    },
    methods: {
        ...mapMutations(["setParamFromFormData", "setValidForm"]),
        compulsory(fieldName) {
            if (! fieldName) return '';
            return `${this.trans[this.lang].fields[fieldName].replace(
                "*",
                ""
            )} ${this.trans[this.lang].compulsory}`;
        }
    },
    created() {
        this.lang = window.appLocale;
    }
};
</script>

<style lang="scss">
input:-internal-autofill-selected {
    -webkit-appearance: menulist-button;
    background-color: transparent !important;
    background-image: none !important;
    color: -internal-light-dark-color(black, white) !important;
}
.province-school-component {
    display: block !important;
    > div {
        width: 100%;
        padding-left: 0;
        padding-right: 0;
    }
}
.form-data-component {
    .v-input__control {
        min-height: 70px;
    }
}
</style>
